const actions = {
  GET_REFERRAL_BEGIN: 'GET_REFERRAL_BEGIN',
  GET_REFERRAL_SUCCESS: 'GET_REFERRAL_SUCCESS',
  GET_REFERRAL_FAILED: 'GET_REFERRAL_FAILED',

  ADD_REFERRAL_BEGIN: 'ADD_REFERRAL_BEGIN',
  ADD_REFERRAL_SUCCESS: 'ADD_REFERRAL_SUCCESS',
  ADD_REFERRAL_FAILED: 'ADD_REFERRAL_FAILED',

  UPDATE_REFERRAL_BEGIN: 'UPDATE_REFERRAL_BEGIN',
  UPDATE_REFERRAL_SUCCESS: 'UPDATE_REFERRAL_SUCCESS',
  UPDATE_REFERRAL_FAILED: 'UPDATE_REFERRAL_FAILED',

  DELETE_REFERRAL_BEGIN: 'DELETE_REFERRAL_BEGIN',
  DELETE_REFERRAL_SUCCESS: 'DELETE_REFERRAL_SUCCESS',
  DELETE_REFERRAL_FAILED: 'DELETE_REFERRAL_FAILED',

  getReferralBegin: () => {
    return {
      type: actions.GET_REFERRAL_BEGIN,
    };
  },

  getReferralSuccess: data => {
    return {
      type: actions.GET_REFERRAL_SUCCESS,
      data,
    };
  },

  getReferralFailed: err => {
    return {
      type: actions.GET_REFERRAL_FAILED,
      err,
    };
  },

  addReferralBegin: () => {
    return {
      type: actions.ADD_REFERRAL_BEGIN,
    };
  },

  addReferralSuccess: data => {
    return {
      type: actions.ADD_REFERRAL_SUCCESS,
      data,
    };
  },

  addReferralFailed: err => {
    return {
      type: actions.ADD_REFERRAL_FAILED,
      err,
    };
  },

  updateReferralBegin: () => {
    return {
      type: actions.UPDATE_REFERRAL_BEGIN,
    };
  },

  updateReferralSuccess: data => {
    return {
      type: actions.UPDATE_REFERRAL_SUCCESS,
      data,
    };
  },

  updateReferralFailed: err => {
    return {
      type: actions.UPDATE_REFERRAL_FAILED,
      err,
    };
  },

  deleteReferralBegin: () => {
    return {
      type: actions.DELETE_REFERRAL_BEGIN,
    };
  },

  deleteReferralSuccess: data => {
    return {
      type: actions.DELETE_REFERRAL_SUCCESS,
      data,
    };
  },

  deleteReferralFailed: err => {
    return {
      type: actions.DELETE_REFERRAL_FAILED,
      err,
    };
  },
};

export default actions;